export default __webpack_public_path__ + "static/media/inline7.48ad979b.jpg";